import PhoneInput from "react-phone-number-input";

export default function CustomPhoneInput({
  value,
  onChange,
  error,
  disabled = false,
  placeholder = "Enter your phone number",
  defaultCountry = "PK",
  country,
  required = false,
  label = "Phone Number",
  variant = "legacy",
  labelClassName = "",
  id,
}) {
  if (variant === "tailwind") {
    const labelClasses =
      labelClassName || "mb-1 block text-xs font-medium text-gray-700";
    return (
      <div className="min-w-0 w-full">
        {label ? (
          <label className={labelClasses} htmlFor={id}>
            {label}
            {required ? <span className="text-red-500">*</span> : null}
          </label>
        ) : null}
        <div
          className={`cms-tailwind-phone-field${error ? " cms-tailwind-phone-field--error" : ""}`}
        >
          <PhoneInput
            id={id}
            international
            countryCallingCodeEditable={false}
            defaultCountry={defaultCountry}
            country={country}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            disabled={disabled}
            className="cms-tailwind-phone__control"
          />
        </div>
        {error ? <p className="mt-1 text-xs font-medium text-red-500">{error}</p> : null}
        <style jsx global>{`
          .cms-tailwind-phone-field .cms-tailwind-phone__control,
          .cms-tailwind-phone-field .PhoneInput {
            display: flex !important;
            align-items: center !important;
            width: 100% !important;
            gap: 0.5rem !important;
          }

          .cms-tailwind-phone-field .PhoneInputCountry {
            flex: 0 0 3.25rem !important;
            min-width: 3.25rem !important;
            max-width: 3.25rem !important;
            width: 3.25rem !important;
            height: 2.625rem !important;
            margin: 0 !important;
            padding: 0 0.25rem !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            border-radius: 0.5rem !important;
            border: 1px solid #d1d5db !important;
            background: #fff !important;
            box-shadow: none !important;
            position: relative !important;
            overflow: visible !important;
          }

          .cms-tailwind-phone-field .PhoneInputCountrySelect {
            position: absolute !important;
            inset: 0 !important;
            width: 100% !important;
            height: 100% !important;
            opacity: 0 !important;
            cursor: pointer !important;
            margin: 0 !important;
            padding: 0 !important;
          }

          .cms-tailwind-phone-field .PhoneInputCountryIcon,
          .cms-tailwind-phone-field .PhoneInputCountryIconImg {
            width: 1.35rem !important;
            height: 1rem !important;
            margin: 0 !important;
            box-shadow: none !important;
            background: transparent !important;
          }

          .cms-tailwind-phone-field .PhoneInputCountrySelectArrow {
            display: none !important;
          }

          .cms-tailwind-phone-field .PhoneInputInput,
          .cms-tailwind-phone-field input[type="tel"] {
            flex: 1 1 0% !important;
            min-width: 0 !important;
            width: 100% !important;
            height: 2.625rem !important;
            border-radius: 0.5rem !important;
            border: 1px solid #d1d5db !important;
            padding: 0 0.75rem !important;
            font-size: 0.875rem !important;
            line-height: 1.25rem !important;
            background: #fff !important;
            color: #111827 !important;
            box-shadow: none !important;
            transition: border-color 0.15s ease, box-shadow 0.15s ease;
          }

          .cms-tailwind-phone-field .PhoneInputInput::placeholder {
            color: #9ca3af;
          }

          .cms-tailwind-phone-field .PhoneInputInput:focus,
          .cms-tailwind-phone-field input[type="tel"]:focus {
            border-color: #007bff !important;
            outline: none !important;
            box-shadow: 0 0 0 1px #007bff !important;
          }

          .cms-tailwind-phone-field--error .PhoneInputCountry,
          .cms-tailwind-phone-field--error .PhoneInputInput,
          .cms-tailwind-phone-field--error input[type="tel"] {
            border-color: #fca5a5 !important;
          }

          .cms-tailwind-phone-field--error .PhoneInputInput:focus,
          .cms-tailwind-phone-field--error input[type="tel"]:focus {
            border-color: #ef4444 !important;
            box-shadow: 0 0 0 1px #ef4444 !important;
          }

          .cms-tailwind-phone-field .PhoneInput--disabled .PhoneInputCountry,
          .cms-tailwind-phone-field .PhoneInput--disabled .PhoneInputInput {
            background: #f9fafb !important;
            opacity: 0.7;
            cursor: not-allowed;
          }
        `}</style>
      </div>
    );
  }

  return (
    <div className="col-12 mb-3">
      <div className="form-group w-100">
        {label && (
          <label className="acc-label2 mb-1">
            {label}
            {required && <span className="ms-1 text-danger">*</span>}
          </label>
        )}

        <div className={`phone-input-wrapper d-flex ${error ? "error" : ""}`}>
          <PhoneInput
            international
            defaultCountry={defaultCountry}
            country={country}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            disabled={disabled}
            className="custom-phone-input"
          />
        </div>

        {error && (
          <div className="invalid-feedback d-flex align-items-center mt-1">
            <i className="bi bi-exclamation-circle-fill me-1 fs-6"></i>
            {error}
          </div>
        )}
      </div>

      <style jsx global>{`
        /* Hide the default dropdown arrow */
        .custom-phone-input .PhoneInputCountrySelectArrow {
          display: none !important;
        }

        /* Make the input group one line */
        .custom-phone-input {
          display: flex !important;
          width: 100% !important;
          align-items: center !important;
        }

        /* Country container - wider */
        .custom-phone-input .PhoneInputCountry {
          display: flex !important;
          align-items: center !important;
          background-color: rgb(239 240 255) !important;
          border: 1px solid #ced4da !important;
          border-radius: 0.25rem !important;
          padding: 0 8px !important;
          height: 36px !important;
          margin-right: 6px !important;
          flex-shrink: 0 !important;
          min-width: 140px !important;
          max-width: 200px !important;
          overflow: hidden;
          position: relative; /* For positioning custom arrow */
        }

        /* Flag icon */
        .custom-phone-input .PhoneInputCountryIconImg {
          width: 24px !important;
          height: 18px !important;
          background-color: rgb(239 240 255) !important;
          border-radius: 3px !important;
          margin-right: 6px !important;
          margin-bottom: 5px !important;
          flex-shrink: 0 !important;
        }

        /* Country dropdown */
        .custom-phone-input .PhoneInputCountrySelect {
          font-size: 14px !important;
          border: none !important;
          background: transparent !important;
          font-family: inherit !important;
          cursor: pointer !important;
          width: 100% !important;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-right: 20px; /* Space for arrow */
          padding-left:20px !important
          appearance: none !important; /* Remove default dropdown styling */
        }

        /* Phone number input */
        .custom-phone-input .PhoneInputInput {
          flex: 1 1 auto !important;
          min-width: 50px !important;
          height: 36px !important;
          padding: 0.375rem 0.75rem !important;
          font-size: 15px !important;
          font-family: inherit !important;
          background-color: rgb(239 240 255) !important;
          border: 1px solid #ced4da !important;
          border-radius: 0.25rem !important;
          transition: border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out !important;
          color: #212529 !important;
          background-clip: padding-box !important;
        }

        /* Focus state */
        .custom-phone-input .PhoneInputInput:focus {
          border-color: #86b7fe !important;
          outline: 0 !important;
          box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;
        }

        /* Disabled */
        .custom-phone-input .PhoneInputInput:disabled,
        .custom-phone-input .PhoneInputCountry:disabled {
          background-color: #e9ecef !important;
          opacity: 1 !important;
        }

        /* Error state */
        .phone-input-wrapper.error .custom-phone-input .PhoneInputInput,
        .phone-input-wrapper.error .custom-phone-input .PhoneInputCountry {
          border-color: #dc3545 !important;
        }

        .phone-input-wrapper.error .custom-phone-input .PhoneInputInput:focus {
          box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25) !important;
        }

        /* Ensure wrapper is inline */
        .phone-input-wrapper {
          display: flex !important;
          align-items: center !important;
          width: 100% !important;
          gap: 0 !important;
        }


        /* Country select container */
        .custom-phone-input .PhoneInputCountrySelectContainer {
          position: relative;
          flex: 1;
          min-width: 0;
          overflow: hidden;
        }

        /* Error message */
        .invalid-feedback {
          font-size: 0.8rem !important;
        }

        /* Make country dropdown wider */
        .PhoneInputCountryDropdown {
          min-width: 250px !important;
        }
      `}</style>
    </div>
  );
}
